import type { AdvertisingConsentChoice } from "@/lib/advertisingConsent";

/** Sends initial defaults or a later choice through the same Google consent signals. */
export function setGoogleConsent(
  choice: AdvertisingConsentChoice,
  command: "default" | "update" = "update",
): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("consent", command, {
    ad_personalization: choice,
    ad_storage: choice,
    ad_user_data: choice,
    analytics_storage: choice,
  });
}
